import React from 'react';
import styles from './Card.module.css';
import VBox from '../../components/layout/VBox';
import HBox from '../../components/layout/HBox';
import Botao from '../../components/Botao';
import { mdiBug, mdiPen, mdiPlay, mdiTrashCan } from '@mdi/js';
import BotaoPerigoso from '../../components/BotaoPerigoso';
import IconeCanal from '../../components/layout/IconeCanal';
import IconeDiagnostico from '../../components/layout/IconeDiagnostico';
import { TRIGGER_TYPE_OPTIONS } from '@tera/shared/src/fluxoConfig/nodes/chatbot/start';

type CardProps = {
  item: any;
  onRemove: () => void;
  onPlay?: () => void;
  onAck?: () => void;
};

const CardContents = ({ item, onRemove, onPlay, onAck }: CardProps) => {
  return (
    <VBox>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div className={styles.title}>{item.nome}</div>
        <div className={styles.initialization}>{TRIGGER_TYPE_OPTIONS[item.inicializacao]}</div>
      </div>
      <HBox>
        <IconeCanal tipo={item.canal?.tipo} style={{ height: '16px' }} />
        <div className={styles.description}>
          {item.canal?.nome ?? '(Sem canal)'}
        </div>
      </HBox>
      <hr style={{ color: 'var(--tc-color-gray-200)', height: 1 }} />
      <HBox stretch>
        <HBox style={{ flex: 1, alignItems: 'center', gap: '4px' }}>
          <div className={styles.qtd}>
            [#{item.id}] {item.qtdBlocos} blocos, {item.qtdConexoes} conexões
          </div>
          <IconeDiagnostico diagnosticos={item.diagnosticos ?? []} dialogoId={item.id} onAck={onAck} />
        </HBox>
        <HBox style={{ flex: '0 1' }}>
          {onPlay && (
            <Botao
              variant="none-info"
              icon={mdiPlay}
              title="Iniciar conversa"
              onClick={(e: any) => {
                e.preventDefault();
                e.stopPropagation();
                onPlay?.();
              }}
            ></Botao>
          )}
          {item.versao !== 1 && (
            <Botao
              variant="none-info"
              icon={mdiBug}
              href={`/dialogo/${item.id}/debug`}
              title="Depurar fluxo"
            ></Botao>
          )}
          {item.versao !== 1 && (
            <Botao
              variant="none-primary"
              icon={mdiPen}
              href={`/dialogo/${item.id}`}
            ></Botao>
          )}
          <BotaoPerigoso
            variant="none-danger"
            icon={mdiTrashCan}
            confirmation={
              <div>
                <p>
                  Se excluir o fluxo, algumas conversas automatizadas podem
                  parar de funcionar.
                </p>
                <p>Tem certeza que deseja excluir?</p>
              </div>
            }
            onClick={onRemove}
          ></BotaoPerigoso>
        </HBox>
      </HBox>
    </VBox>
  );
};

const Card = ({ item, onRemove, onPlay, onAck }: CardProps) => {
  return (
    <div className={styles.container}>
      <CardContents item={item} onRemove={onRemove} onPlay={onPlay} onAck={onAck} />
    </div>
  );
};

export default Card;
